<template>
	<div class="container">
		<top :currentComponent="currentComponent" @Select="Select" :topList="topList"></top>
		<component :is="currentComponent"></component>
	</div>
</template>
<script>
	import top from "@/views/mechanism/children/top";
	import personalInformation from './components/myBoardChild/personalInformation'
	import personalInformationSetting from './components/myBoardChild/personalInformationSetting'
	export default {
		components: {
			top,
			personalInformation,
			personalInformationSetting
		},
		data() {
			return {
				topList: [{
						name: "个人信息",
						to: "personalInformation",
					},
					{
						name: "个人信息设置",
						to: "personalInformationSetting",
					},
				],
					currentComponent:'personalInformation',
				}
			},
			methods:{
				Select(val) {
					this.currentComponent = val
				}
			},
			mounted() {
				console.log(this.$route.query,'看看坎坎坷坷');
				let data = this.$route.query
				if(JSON.stringify(data) !== '{}') {
					 this.currentComponent = data.currentComponent
				}
			},
		}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
	}
</style>
